import { useContext } from "react";
import { FbaseAuthUserContext } from "../fbase";

const useAuthentication = () => {
  const authUser = useContext(FbaseAuthUserContext);
  const doneAuthenticating = authUser !== false;
  return { doneAuthenticating, authUser };
};
export default useAuthentication;
